var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    !_vm.isCognito && _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _vm.isCognito
      ? _c("div", { staticClass: "login" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: require(`@/assets/${_vm.logo}.png`),
              width: "15%",
              height: "15%",
            },
          }),
          _c(
            "div",
            { staticClass: "rounded border", attrs: { id: "inputform" } },
            [
              _c(
                "form",
                {
                  staticClass: "login_form rounded",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.tenantLabel)),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hospitalCode,
                          expression: "hospitalCode",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: [[_vm.tenantLabel]],
                        required: "",
                      },
                      domProps: { value: _vm.hospitalCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.hospitalCode = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("ID"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userCode,
                          expression: "userCode",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "ユーザーID",
                        required: "",
                      },
                      domProps: { value: _vm.userCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.userCode = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("パスワード"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        placeholder: "パスワード",
                        required: "",
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm.isMessage
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" },
                        },
                        [_vm._v(" " + _vm._s(_vm.message) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-block",
                      class: { loginbtn: !_vm.isMessage },
                    },
                    [_vm._v("ログイン")]
                  ),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }